module.exports = __webpack_public_path__ + "static/media/Virtual-mirror-lens-4-psd_Fresh-green.9cf28a51.png";